function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "#4A4A4A",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.5 9.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5S11 11.83 11 11s-.67-1.5-1.5-1.5zm2.5.5v2h12v-2H12zM9.5 14.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5S11 16.83 11 16s-.67-1.5-1.5-1.5zm2.5.5v2h12v-2H12zM9.5 19.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5S11 21.83 11 21s-.67-1.5-1.5-1.5zm2.5.5v2h12v-2H12z"
}))));